var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shop-section" }, [
    !!_vm.$slots.preamble
      ? _c(
          "p",
          { staticClass: "shop-section__preamble" },
          [_vm._t("preamble")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !!_vm.$slots.headline
      ? _c(
          "h2",
          { staticClass: "shop-section__headline" },
          [_vm._t("headline")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !!_vm.$slots.orderlimiterror
      ? _c(
          "div",
          { staticClass: "orderlimit-error" },
          [_vm._t("orderlimiterror")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !!_vm.$slots.body || !!_vm.$slots.default
      ? _c(
          "div",
          { staticClass: "shop-section__body" },
          [_vm._t("default"), _vm._v(" "), _vm._t("body")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }